<template>
  <div class="resume-school-modal">
    <transition name="fade">
      <div
        v-if="visible"
        class="background-cover"
        @click="close"
      ></div>
    </transition>
    <transition name="scale">
      <div
        v-if="visible"
        class="school-logo-container"
      >
        <div class="school-logo-title">添加校徽</div>
        <div class="school-title-content flex items-center">
          <div class="sub-title">校徽库</div>
          <div class="tips">（收录了国内 985 211学校校徽）</div>
        </div>
        <div class="flex items-start">
          <EditorAutoComplete
            :value="keywords"
            placeholder="请输入学校名称"
            clearable
            style="width: 100%"
            value-key="name"
            display-key="name"
            style-type="2"
            :remoteMethodCallback="fetchSchoolLogosRemoteMethod"
            border
            @clickPickerItem="clickPickerItem"
          />
          <div
            class="flex flex-col"
            style="margin-left: 24px"
          >
            <div
              class="upload-btn"
              @click="clickUploadRef"
            >
              本地上传
            </div>
            <div class="upload-btn-tips">（文件小于1MB）</div>
          </div>
        </div>
        <div class="preview-title">校徽预览</div>
        <div class="preview-content flex items-center">
          <img
            v-if="logoImage"
            class="w-full h-full object-contain"
            :src="logoImage"
            alt=""
          />
        </div>
        <div
          class="flex justify-end items-center"
          style="margin-top: 52px"
        >
          <CompleteButton
            text="取消"
            type="cancel"
            @clickBtn="close"
          />
          <CompleteButton
            text="确定"
            type="confirm"
            style="margin-left: 16px"
            @clickBtn="clickConfirm"
          />
        </div>
        <input
          ref="uploadInputRef"
          type="file"
          accept="image/*"
          style="display: none"
          @change="logoUpload"
        />
      </div>
    </transition>
  </div>
</template>
<script>
import api from '@/api';
import { mapState } from 'vuex';
import EditorAutoComplete from '../EditorAutoComplete/EditorAutoComplete.vue';
import CompleteButton from '../CompleteButton/CompleteButton.vue';
import { uploadMixin } from '../../mixins/upload';
export default {
  mixins: [uploadMixin],
  components: {
    EditorAutoComplete,
    CompleteButton,
  },
  data() {
    return {
      visible: false,
      keywords: '',
      logoImage: '',
      logoId: null,
    };
  },
  computed: {
    ...mapState('editor', ['cvDetail']),
    ...mapState('me', ['personInfo']),
    isMember() {
      return this.personInfo.is_membership;
    },
  },
  methods: {
    show() {
      if (this.cvDetail.basic_info.school_logo) {
        this.logoImage = this.cvDetail.basic_info.school_logo;
        this.logoId = this.cvDetail.basic_info.school_logo_id;
      }
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    async fetchSchoolLogosRemoteMethod(query) {
      try {
        if (!query) return [];
        const res = await api.cvsEditor.getSchoolLogo(this.cvDetail.basic_info.token, {
          school_name: query,
        });
        if (res.code === 1000) {
          return {
            code: 1000,
            data: res.data.logos,
          };
        }
      } catch (error) {
        console.log(error);
      }
    },
    clickPickerItem(data, operation) {
      if (operation === 'click') {
        this.logoImage = data.logo_url;
        this.logoId = data.id;
      }
    },
    async logoUpload() {
      const url = await this.uploadInputChange();
      const ossUrl = await this.uploadFileToOSS(url, 'cv/school_logs/');
      if (url) {
        this.logoImage = ossUrl;
        this.logoId = null;
        this.keywords = '';
      }
    },
    async clickConfirm() {
      if (!this.logoImage) {
        return this.$message.error('请上传或选择校徽');
      }
      // if (!this.isMember) {
      //   this.$emit('buyMember');
      //   return this.$message.error('该功能为会员专享');
      // }
      const { basic_info } = this.cvDetail;
      if (basic_info.kind === 'template' || basic_info.kind === 'sample') {
        this.$store.dispatch('editor/createCvDetail', {
          payload: {
            ...this.cvDetail,
            basic_info: {
              ...basic_info,
              school_logo_url: this.logoImage,
              school_logo_id: this.logoId,
            },
          },
          dontReload: true,
        });
      } else {
        try {
          const res = await api.cvsEditor.updateVipMembershipInfo(basic_info.token, {
            school_logo_url: this.logoImage,
            school_logo_id: this.logoId,
          });
          if (res.code === 1000) {
            this.$message.success('校徽添加成功');
            this.$store.commit('editor/setCvDetail', {
              ...this.cvDetail,
              basic_info: {
                ...basic_info,
                school_logo_url: this.logoImage,
                school_logo_id: this.logoId,
              },
            });
          } else {
            if (res.code === 600213) {
              this.$emit('buyMember');
            }
            this.$message.error(res.message);
          }
          this.close();
        } catch (error) {
          console.log(error);
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/variable.scss';
.resume-school-modal {
  .background-cover {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba($color: #000000, $alpha: 0.5);
    z-index: 299;
  }
  .school-logo-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 446px;
    height: 449px;
    z-index: 301;
    background-color: $form-bg-color;
    border-radius: 12px;
    box-sizing: border-box;
    padding: 28px 32px 32px;
    .school-logo-title {
      font-size: 18px;
      font-weight: 600;
      color: $confirm-title-color;
      margin-bottom: 30px;
    }
    .school-title-content {
      margin-bottom: 10px;
      .sub-title {
        font-size: 14px;
        color: $confirm-title-color;
        margin-right: 6px;
      }
      .tips {
        color: #5b616e;
        font-size: 12px;
      }
    }
    .upload-btn {
      @apply flex justify-center items-center cursor-pointer;
      width: 110px;
      height: 36px;
      border: 1px solid $theme-color;
      color: $theme-color;
      border-radius: 6px;
      text-align: center;
      line-height: 36px;
      margin-bottom: 10px;
    }
    .upload-btn-tips {
      color: $tips-color;
      font-size: 12px;
    }
    .preview-title {
      font-size: 14px;
      color: $confirm-title-color;
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .preview-content {
      width: 308px;
      height: 115px;
      border-radius: 6px;
      border: 1px solid $modal-input-border-color;
      background-color: $modal-input-bg1-color;
    }
  }
}
</style>
